import { render } from "./FraudexCheckModal.vue?vue&type=template&id=267005f7&scoped=true&ts=true"
import script from "./FraudexCheckModal.vue?vue&type=script&lang=ts"
export * from "./FraudexCheckModal.vue?vue&type=script&lang=ts"

import "./FraudexCheckModal.vue?vue&type=style&index=0&id=267005f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267005f7"]])

export default __exports__